import { useRole } from "../context/RoleContext";

export default function RequireRole({ allowedRoles, children }) {
  const { profileRole, loading } = useRole();

  if (loading) {
    return <p style={{ padding: 40 }}>Chargement…</p>;
  }

  // admin a accès à tout
  if (profileRole === "admin") {
    return children;
  }

  // autres rôles
  if (!allowedRoles.includes(profileRole)) {
    return (
      <div style={{ padding: 60, textAlign: "center" }}>
        <h2>Accès refusé</h2>
        <p>Contenu réservé aux administrateurs.</p>
      </div>
    );
  }

  return children;
}
